import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { EdiExportDownloadResponse } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

const useGetEdiUserManualApi = () => {
  const query = useQuery<EdiExportDownloadResponse>({
    queryKey: queryKeys.ediAdmin.userManual(),
    enabled: false,
    queryFn: async () => {
      const res = await axiosInstance.get<EdiExportDownloadResponse>(api.getEdiUserManual);
      return res.data;
    },
  });

  return {
    getUserManualExecute: query.refetch,
    getUserManualLoading: query.isFetching,
    userManualData: query.data,
  };
};

export default useGetEdiUserManualApi;
